export default __webpack_public_path__ + "static/media/ic_list.45783b12.svg";